<div class="pos-relative full-grow-no-shrink-no-basis">
  <div class="keno-grid-container">
    <particle-virtual-grid (columnHeaderButtonClicked)="onColumnHeaderButtonClicked($event)"
                           (selectionChanged)="onSelectionChanged($event)"
                           (valueChanged)="onGridCellValueChange($event)"
                           [api]="api"
                           [invalidateSubject]="handler.invalidateSubject"
                           [parameters]="selectedTab?.tabData"
                           [serviceName]="serviceName"
                           [sourceKey]="sourceType"
                           [sortFieldKey]="sortFieldKey"
                           [sortDirection]="sortDirection"
                           [IsGridReadOnly]="selectedTab?.tabData?.IsReadOnly"
                           tabStyle="compact"
                           version="v2">
    </particle-virtual-grid>
  </div>
</div>
